export const Auth = () => {
  const tk_uac = localStorage.getItem('tk_uac') ? true : false;
  const token = tk_uac ? localStorage.getItem('tk_uac') : false;

  return token;
};
